export const STRING_REGEX = /[\x00-\x1f\x7f]+/; // eslint-disable-line no-control-regex
//# sourceMappingURL=STRING_REGEX.js.map